import { useCallback, useState } from 'react';

import UsersClient from 'src/clients/UsersClient';
import { useAppSelector } from 'src/hooks/useStore';

/**
 * Opens Stripe's hosted account-onboarding flow for the connected account so
 * the user can complete the outstanding requirements (ToS acceptance, KYC)
 * that keep `us_bank_account_ach_payments` inactive. This lands them where they
 * actually resolve the capability, unlike a plain dashboard login link. The
 * link is single-use, so we fetch one on demand.
 */
export const useOpenStripeAchSetup = () => {
  const accountId = useAppSelector((state) => state.payments.accountInfo?.id);
  const [isOpening, setIsOpening] = useState(false);

  const openStripeAchSetup = useCallback(async () => {
    if (!accountId || isOpening) {
      return;
    }
    setIsOpening(true);
    try {
      const result = await UsersClient.getAccountOnboardingLink(accountId);
      const url = result?.data?.url;
      if (url) {
        window.open(url, '_blank');
      }
    } catch (error) {
      console.error('Failed to open Stripe ACH setup', error);
    } finally {
      setIsOpening(false);
    }
  }, [accountId, isOpening]);

  return {
    openStripeAchSetup,
    canOpenStripeAchSetup: Boolean(accountId),
    isOpeningStripeAchSetup: isOpening,
  };
};
